module.exports = "/images/landing-map.png?6ba586805b44f74e023d5e237aa89e26";